import { useDispatch } from 'react-redux';
import { type AppDispatch } from './types.js';

export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
